import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import { Box, Button, FelaCSS, MultilineEllipsis } from '@bridebook/ui';
import componentStyles from './supplier-card-description.style';

interface IProps {
  description: string;
  linesAmount?: number;
  style?: FelaCSS;
}

const SupplierCardDescriptionComponent = ({ description, linesAmount = 2, style = {} }: IProps) => {
  const { t } = useTranslation('supplier');
  const styles = componentStyles();

  return (
    <Box style={Object.assign(styles.wrapper, style)}>
      <MultilineEllipsis lines={linesAmount} fontSize={14}>
        {description}
      </MultilineEllipsis>
      <Box style={styles.buttonWrap}>
        <Button theme="ghost" text={t('button.readMore')} />
      </Box>
    </Box>
  );
};

export const SupplierCardDescription = memo(SupplierCardDescriptionComponent);
